import { useState, useEffect } from 'react';
import axios from 'axios';

interface MempoolAddressResponse {
  chain_stats: {
    funded_txo_sum: number;
    spent_txo_sum: number;
  };
  mempool_stats: {
    funded_txo_sum: number;
    spent_txo_sum: number;
  };
}

export function useWalletBalance(address: string | null | undefined) {
  const [balance, setBalance] = useState<number | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!address) {
      setBalance(null);
      return;
    }

    let cancelled = false;
    setIsLoading(true);

    axios
      .get<MempoolAddressResponse>(`https://mempool.space/api/address/${address}`)
      .then((res) => {
        if (cancelled) return;
        const { chain_stats } = res.data;
        const balanceSats = chain_stats.funded_txo_sum - chain_stats.spent_txo_sum;
        setBalance(balanceSats / 1e8);
      })
      .catch(() => {
        if (!cancelled) setBalance(null);
      })
      .finally(() => {
        if (!cancelled) setIsLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [address]);

  return { balance, isLoading };
}
